module.exports = __webpack_public_path__ + "media/images/payments/switch-dark-f6b5bf2c23432efed6b3832c5ed261de.svg";